// extracted by mini-css-extract-plugin
var _1 = "rbHOs__menu";
var _2 = "rbHOs__wheel";
export { _1 as "menu", _2 as "wheel" }
